<!-- about -->
<template>
  <div class="about">
    <div class="bgBox section1">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p1">赛迈特是专业从事悬浮冶金技术开发的高科技企业</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2" id="公司简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1"><span>公司</span>简介</div>
                <div class="p2"></div>
                <div class="p3">ABOUT US</div>
                <div class="p4">
                  深圳市赛迈特新材料有限公司成立于2016年11月09日，注册资金1100万元，坐落于深圳市坪山区华瀚科技工业园区，与深圳市3D打印制造业创新中心比邻而居，是一家以悬浮冶金为核心技术的设备制造企业和金属材料供应企业，也是国内顶尖专业开发悬浮熔炼技术的科技型企业。公司拥有12项获得授权的专利，通过了ISO9001:2015认证，被深圳市科技创新委员会认定为国家高新技术企业。
                </div>
                <div class="p5">
                  在悬浮冶金领域，赛迈特达到了国际先进，国内领先的水平:
                </div>
              </div>
            </div>
            <div class="box2">
              <div class="imgBox">
                <img src="../../static/images/about/简介.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="p5">
              ★悬浮能力强：熔池驼峰的高/径比=2.0~3.0，在熔炼过程中凝壳很少；
            </div>
            <div class="p5">
              ★熔炼温度高：最高熔炼温度可达3600℃，能熔炼包括钨、钽、钼、铌等各种难熔金属；
            </div>
            <div class="p5">★规格范围广：熔炼量从50g~200kg的规格系列；</div>
            <div class="p5">
              ★与多种现代技术的结合：离心铸、底铸、吸铸、连续拉锭、电弧熔炼、等离子熔炼等。
            </div>
          </div>
        </div>
        <div class="blockBox">
          <div class="left">
            <div class="item item1">
              <div class="p1">企业经营宗旨</div>
              <div class="p2"></div>
              <div class="p3">Our Tenet</div>
              <div class="p4">产品质量为首、客户利益至上</div>
            </div>
            <div class="flx">
              <div class="item item2">
                <div class="p1">愿景</div>
                <div class="p2"></div>
                <div class="p3">Our Vision</div>
                <div class="p4">打造国内领先的新材料创新平台</div>
              </div>
              <div class="item item3">
                <div class="p1">核心价值观</div>
                <div class="p2"></div>
                <div class="p3">Our Core values</div>
                <div class="p4">以人为本、产研结合、服务至上</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="item item4">
              <div class="p1">使命</div>
              <div class="p2"></div>
              <div class="p3">Our Mission</div>
              <div class="p4">助力科研，服务产业</div>
            </div>
            <div class="item item5">
              <div class="p1">文化</div>
              <div class="p2"></div>
              <div class="p3">Our Culture</div>
              <div class="p4">专业 • 勤奋• 务实• 感恩</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3" id="发展历程">
      <div class="sdBox"></div>
      <div class="s3_innerBox typeArea">
        <div class="topTitle leftTop">
          <div class="p1"><span>发展</span>历程</div>
          <div class="p2"></div>
          <div class="p3">MILESTONES</div>
          <div class="img"></div>
          <!-- <img src="../../static/images/smeltingEquipment/设备应用.jpg" alt=""> -->
        </div>
        <div class="treeBox">
          <div class="mid">
            <div class="line line1"></div>
            <div class="round left">
              <div class="span">2022</div>
              <div class="contbox">
                <div class="p1">定位材料研发平台找略</div>
                <div class="p2">
                  定位新战略，联合学术与产业优势创新力量，打造先进新材料创新平台，致力于提升新材料产业的技术创新能力和商业化应用能力
                </div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span">2020</div>
              <div class="contbox">
                <div class="p1">50kg级熔炼设备</div>
                <div class="p2">
                  设备从熔炼能力达到50kg每炉，实现了铝钪靶材等特殊材料的规模化生产
                </div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round left">
              <div class="span">2019</div>
              <div class="contbox">
                <div class="p1">突破新的熔炼温度</div>
                <div class="p2">
                  熔炼温度突破到3400 ℃
                  ，实现了钨、钽、铼等难熔金属及其合金的熔炼
                </div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span">2018</div>
              <div class="contbox">
                <div class="p1">20kg级熔炼设备</div>
                <div class="p2">
                  设备从熔炼能力达到20kg每炉，具备某些特殊材料小批量工业生产规模，实现了从实验室到规模化生产的飞跃
                </div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round left">
              <div class="span">2017</div>
              <div class="contbox">
                <div class="p1">5kg级熔炼设备</div>
                <div class="p2">
                  成功研发出5kg悬浮熔炼设备，熔炼温度达到2800℃以上，能够熔炼金属钼及其合金。同年获得深圳市创业资助50万元
                </div>
              </div>
            </div>
            <div class="line line2"></div>
            <div class="round right">
              <div class="span">2016</div>
              <div class="contbox">
                <div class="p1">公司成立</div>
                <div class="p2">公司成立，设计、制造和研发悬浮熔炼设备</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4" id="荣誉资质">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1"><span>荣誉</span>资质</div>
          <div class="p2"></div>
          <div class="p3">OUR HONOR AND QUALIFICATION</div>
        </div>
        <div class="selectBox">
          <div class="selInerBox">
            <div
              class="item"
              :class="active == 1 ? 'active' : ''"
              @click="section4Func(1)"
            >
              高新企业
            </div>
            <div
              class="item"
              :class="active == 2 ? 'active' : ''"
              @click="section4Func(2)"
            >
              专精特新中小企业
            </div>
            <div
              class="item"
              :class="active == 3 ? 'active' : ''"
              @click="section4Func(3)"
            >
              创新型中小企业
            </div>
            <div
              class="item"
              :class="active == 4 ? 'active' : ''"
              @click="section4Func(4)"
            >
              资质证书
            </div>
            <div
              class="item"
              :class="active == 5 ? 'active' : ''"
              @click="section4Func(5)"
            >
              知识专利
            </div>
          </div>
        </div>
        <div class="bodyBox bodyBox1" v-if="active == 1">
          <img
            style="width: 610px; height: 368px"
            src="../../static/images/about/高企.jpg"
            alt=""
          />
        </div>
        <div class="bodyBox bodyBox2" v-if="active == 2">
          <img
            style="width: 610px; height: 368px"
            src="../../static/images/about/专精特新.jpg"
            alt=""
          />
        </div>
        <div class="bodyBox bodyBox2" v-if="active == 3">
          <img
            style="width: 610px; height: 368px"
            src="../../static/images/about/创新型.jpg"
            alt=""
          />
        </div>
        <div class="bodyBox bodyBox2" v-if="active == 4">
          <img
            style="width: 906px; height: 640px"
            src="../../static/images/about/证书.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="bgBox section5" v-if="active == 5">
      <div class="innerDiv">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in 12" :key="item">
            <img
              class="pic"
              :src="'../../static/images/about/专利' + item + '.jpg'"
              alt=""
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  components: {},
  data() {
    return {
      active: 1,
      swiperOption: {
        //自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 5,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    if (this.$store.state.pageId) {
      this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    this.$store.commit("savePageId", "");
  },
  methods: {
    init() {},
    section4Func(data) {
      this.active = data;
    },
  },
};
</script>

<style lang='less' scoped>
.about {
  min-width: 1200px;
  height: 100%;

  .section1 {
    width: 100%;
    height: 600px;
    background: url("../../static/images/about/banner.jpg") no-repeat;
    background-position: center;

    .s1_innerBox {
      padding-top: 234px;
      text-align: left;

      .opctBox {
        width: 1245px;
        height: 230px;
        // opacity: 0.4;
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.1) 2%,
          rgba(0, 0, 0, 0.4) 20%,
          rgba(0, 0, 0, 0.4) 80%,
          rgba(255, 255, 255, 0.1) 98%,
          rgba(255, 255, 255, 0) 100%
        );

        .p1 {
          font-size: 48px;
          line-height: 48px;
          padding-top: 50px;
          color: #fefefe;
        }

        .line {
          width: 200px;
          height: 8px;
          margin-top: 85px;
          background-color: #c30000;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    height: 1420px;

    .s2_innerBox {
      height: 100%;
      padding-top: 230px;

      .bodyBox {
        width: 1190px;
        height: 518px;
        padding: 0 0 20px 35px;
        background-color: transparent;
        border: solid 2px #c30000;
        z-index: 99;
        position: relative;

        .top {
          display: flex;
          // height: 363px;

          .box1 {
            flex: 1;

            .topTitle {
              .p1 {
                margin-top: 35px;
              }

              .p3 {
                margin-bottom: 50px;
              }

              .p4,
              .p5 {
                font-size: 16px;
                line-height: 28px;
                color: #545454;
                text-indent: 2em;
                padding-right: 10px;
                font-weight: 400;
              }
            }
          }

          .box2 {
            width: 569px;
            height: 355px;
            position: relative;

            .imgBox {
              width: 622px;
              height: 408px;
              background-color: #ffffff;
              box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
              position: absolute;
              top: -53px;
              right: -53px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }

        .bottom {
          text-align: left;

          .p5 {
            font-size: 16px;
            line-height: 28px;
            color: #545454;
            text-indent: 2em;
            padding-right: 10px;
            font-weight: 400;
          }
        }
      }

      .blockBox {
        width: 510px;
        width: 100%;
        margin-top: 55px;
        display: flex;

        .item {
          background-color: #fbfbfb;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 250px;
          border: 2px solid #fff;

          .p1 {
            font-size: 24px;
            line-height: 24px;
            color: #555555;
            margin-top: 90px;
            transition: all 0.3s;
          }

          .p2 {
            width: 50px;
            height: 4px;
            background-color: #c30000;
            margin: 20px 0;
          }

          .p3 {
            font-size: 16px;
            line-height: 16px;
            color: #555555;
            font-weight: 400;
          }

          .p4 {
            font-size: 16px;
            line-height: 16px;
            color: #555555;
            font-weight: 400;
            margin-top: 33px;
            visibility: hidden;
          }
        }

        .item:hover {
          border: 2px solid #c30000;
          .p1 {
            margin-top: 60px;
          }

          .p4 {
            visibility: initial;
          }
        }

        .left {
          width: 795px;
          margin-right: 10px;
          height: 100%;
          display: flex;
          flex-wrap: wrap;

          .item1 {
            width: 100%;
          }

          .flx {
            margin-top: 10px;
            display: flex;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
          }

          .item2 {
            width: 392px;
          }

          .item3 {
            width: 392px;
          }
        }

        .right {
          width: 392px;
          height: 100%;

          .item4 {
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .section3 {
    // margin-top: 300px;
    width: 100%;
    height: 1400px;
    background-color: #fbfbfb;
    .sdBox {
      height: 300px;
      width: 100%;
      background-color: #ffffff;
    }
    .s3_innerBox {
      position: relative;
      height: 100%;

      .topTitle {
        margin-bottom: 220px;

        .p1 {
          margin-top: -40px;
        }

        .img {
          position: absolute;
          top: -64px;
          left: 500px;
          height: 200px;
          width: calc(~"100vw/2 + 90px");
          background: url("../../static/images/about/历程.jpg") no-repeat;
          background-position: left;
        }
      }

      .treeBox {
        height: 810px;
        display: flex;
        justify-content: center;

        .mid {
          display: flex;
          flex-direction: column;
          align-items: center;

          .round {
            width: 12px;
            height: 12px;
            background-color: #adadad;
            border-radius: 50%;
            margin: 4px 0;
            position: relative;

            .span {
              font-size: 19px;
              color: #c30000;
              position: absolute;
              top: -9px;
            }

            .contbox {
              width: 319px;
              height: 131px;
              background-color: #ffffff;
              position: absolute;
              top: -9px;
              padding: 0 12px;

              .p1 {
                font-size: 19px;
                line-height: 19px;
                margin-top: 5px;
                color: #333333;
              }

              .p2 {
                margin-top: 10px;
                font-size: 16px;
                line-height: 28px;
                color: #666666;
                text-align: left;
              }
            }
          }

          .left.round {
            .span {
              left: -55px;
            }

            .contbox {
              left: -379px;

              .p1 {
                text-align: right;
              }
            }
          }

          .right.round {
            .span {
              right: -55px;
            }

            .contbox {
              right: -379px;

              .p1 {
                text-align: left;
              }
            }
          }

          .line {
            width: 2px;
            background-color: #adadad;
          }

          .line1 {
            height: 50px;
          }

          .line2 {
            height: 100px;
          }
        }
      }
    }
  }

  .section4 {
    width: 100%;
    // height: 525px;

    // margin-bottom: 180px;
    .s4_innerBox {
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 250px;
        }
      }

      .selectBox {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        margin-top: 71px;

        .selInerBox {
          width: 1200px;
          height: 50px;
          display: flex;
          justify-content: space-between;

          .item {
            width: 180px;
            height: 50px;
            line-height: 48px;
            border: solid 1px #c30000;
            font-size: 20px;
            font-weight: 400;
            text-align: center;
            color: #555555;
            cursor: pointer;
          }

          .item.active {
            background-color: #c30000;
            color: #fffefe;
          }
        }
      }

      .bodyBox {
        width: 100%;
        height: 660px;
        display: flex;
        justify-content: center;
        margin-top: 80px;
        margin-bottom: 200px;
        img {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.35);
          border: solid 2px #c30000;
        }
      }
    }
  }

  .section5 {
    height: 660px;
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 200px;
    position: relative;
    .innerDiv {
      width: 1900px;
      height: 660px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      .swiper-container {
        height: 100%;
        display: flex;
        justify-content: center;
        .swiper-slide {
          text-align: center;
          font-size: 18px;
          background: #fff;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: flex-end;
          transition: all 300ms;

          // width: 280px;
          .pic {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.35);
            border: solid 2px #c30000;
            transition: all 300ms;
            width: 280px !important;
            // scale: (0.6);
          }
        }

        .swiper-slide.swiper-slide-prev,
        .swiper-slide.swiper-slide-next {
          // width: 354px!important;
          .pic {
            width: 330px !important;
            // scale: (0.8);
          }
        }

        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          // width: 450px!important;
          // scale: (1);
          .pic {
            width: 400px !important;
            // scale: (1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue